import React, { useState } from "react";

import Box from "./Box";
import Button from "./Button";
import ChevronDownIcon from "../assets/chevron-down-black.svg";
import FadeUpRollover from "./FadeUpRollover";
import HeadingSmall from "./HeadingSmall";
import PropTypes from "prop-types";

function DropdownSection({ heading, content, opacityRollover }) {
  const [active, setActive] = useState(false);
  const buttonInner = (
    <Box display={"flex"} alignItems="center">
      <HeadingSmall pr="7px">{heading}</HeadingSmall>
      <Box flipY={active} display="flex" alignItems="center">
        <ChevronDownIcon />
      </Box>
    </Box>
  );
  return (
    <Box>
      <Button py="15px" width="100%" onClick={() => setActive(!active)}>
        {opacityRollover ? (
          <FadeUpRollover>{buttonInner}</FadeUpRollover>
        ) : (
          buttonInner
        )}
      </Button>
      {active && content}
    </Box>
  );
}

DropdownSection.propTypes = {
  heading: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
};

export default DropdownSection;
